import { ActionType, createAction } from 'typesafe-actions'

export const applyFilter = createAction('APPLY_FILTER')<string>()
export const nextPage = createAction('NEXT_PAGE')()

export type Actions =
  | ActionType<typeof applyFilter>
  | ActionType<typeof nextPage>
